<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>




		<div class="read">
			<div class="read-hd">
				<q-title title="自助核酸" time="86"></q-title>
				<q-step :step="3"></q-step>
			</div>

			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>身份证号码：</span>
					<b>360************131</b>
				</div>
			</div>

			
			<div class="nucleic-acid-items">
				<ul>
					<li class="on">
						<div class="name">
							新型冠状病毒IgM抗体检测
						</div>
						<div class="price">
							价格：60元
						</div>
						<div class="time">
							2021-12-04 02:06
						</div>
					</li>
					<li class="">
						<div class="name">
							新型冠状病毒IgM抗体检测
						</div>
						<div class="price">
							价格：60元
						</div>
						<div class="time">
							2021-12-04 02:06
						</div>
					</li>
					<li class="">
						<div class="name">
							新型冠状病毒IgM抗体检测
						</div>
						<div class="price">
							价格：60元
						</div>
						<div class="time">
							2021-12-04 02:06
						</div>
					</li>
				</ul>
			</div>
			
			<div class="nucleic-acid-total fcc">
				<span>合计:</span><b>180.00</b><span>元</span>
			</div>	
			
			
			
			

			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png">
					<span>首页</span>
				</a>
				<a class="btn-blue fcc" @click="openUrl('/self-pay')">
					<span>自费结算</span>
				</a>
				<a class="btn-orange fcc" @click="useYibao">
						<span>医保结算</span>
				</a>	
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png">
					<span>返回</span>
				</a>
			</div>

		</div>



		<!-- 正在进行医保交易 -->
		<q-pop-yibao v-if="yibaoShow" @click-enter="clickEnter"></q-pop-yibao>
		<!-- 请选择读取信息方式 -->
		<q-pop-read-card v-if="readCard" @click-enter="clickEnter2"></q-pop-read-card>
		
		<!-- 5个读卡的提示弹出框 -->
		<q-pop-read-tips v-if="readTipsShow" :numTips="readIndex" @tips-close="tipsClose"></q-pop-read-tips>
		
		
		
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	
	
	
	//医保交易
	import qPopYibao from '@/components/q-pop/q-pop-yibao.vue';
	//选择 医保读卡
	import qPopReadCard from '@/components/q-pop/q-pop-read-card.vue';
	//读卡提示
	import qPopReadTips from '@/components/q-pop/q-pop-read-tips.vue';
	
	
	export default {
		components: {
			qHead,
			qBanner,
			qStep,
			qTitle
			,qPopYibao,qPopReadCard,qPopReadTips
		},
		data() {
			
			return {
				yibaoShow:false,
				readCard:false,
				readTipsShow:false,
				readIndex:null
			}
		},
		mounted() {
			
		},
		methods: {
			useYibao(){
				var that=this;
				that.readCard=true
				
			},
			
			clickEnter(data){
				this.yibaoShow=false
				this.readCard=false
			},
			clickEnter2(data){
				this.readCard=false
				this.readIndex=data
				this.readTipsShow=true
				
				setTimeout(()=>{
					this.readTipsShow=false
					this.yibaoShow=true
				},1500)
				
			},
			tipsClose(data){
				this.readTipsShow=false
			}
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style  lang="less">

		
	
</style>
